export function relationshipTypeLabel(type) {
  switch (type) {
    case 'many-to-one':
      return 'Many to One';
    case 'many-to-many-implicit':
      return 'Many to Many';
    case 'many-to-many-explicit':
      return 'Many to Many (Explicit)';
    case 'one-to-one':
      return 'One to One';
    case 'embedded':
      return 'Embedded';
    default:
      return type;
  }
}
